import React from 'react';
import { Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const StudentDetail: React.FC = () => {
  const { id } = useParams();
  return (
    <Box>
      <Typography variant="h4">Student Detail {id}</Typography>
    </Box>
  );
};

export default StudentDetail; 